import styled from 'styled-components';

import Row from 'components/Layout/Row';

export default styled(Row)`
  position: fixed;
  margin: 0;
  z-index: ${({ show }) => (show ? '18000' : '-1')};
  background-color: rgba(0, 0, 0, 0.8);
  opacity: ${({ show }) => (show ? '1' : '0')};
  pointer-events: ${({ show }) => (show ? 'all' : 'none')};
  transition: all ${({ show }) => (show ? '0.2s' : '0.1s')};
  overflow: auto;

  .content {
    position: relative;
    height: 100%;
    width: 100%;
    max-height: 90vh;
    max-width: 90vw;
    background-color: #ffffff;
    box-shadow: ${({ theme: { menuShadow } }) => menuShadow};
    transition: ${({ show }) => (show ? 'inherit' : 'all 0.5s')};
    transform: ${({ show }) =>
      show
        ? 'translateY(0) scale(1, 1)'
        : 'translateY(-5px) scale(1.02, 1.02)'};
    border-radius: 4px;
    overflow: hidden;
    /* margin: 30px; */

    iframe {
      position: absolute;
      top: 0;
      left: 0;
    }
  }

  .close-button {
    position: absolute;
    top: 5px;
    right: 5px;
    opacity: 0.7;

    &:hover {
      opacity: 1;
    }
  }
`;
